import { useState } from "react";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface OrderDisplayProps {
  bproducts: any;
  orderid: string;
  logo: string;
  outstangingamount: number;
  getorder: any;
  sessionStorage: Storage;
}

export const useOrderDisplay = ({ bproducts, logo, outstangingamount, getorder, sessionStorage }: OrderDisplayProps) => {
  const [filteredCustomerId, setFilteredCustomerId] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("0");
  const [condition, setcondition] = useState<number>(0);
  const [showBalance, setShowBalance] = useState<boolean>(false);
  const [model, setmodel] = useState<boolean>(false);
  const [glowery, setglowery] = useState<boolean>(false);
  const [confirm, setConfirm] = useState<boolean>(false);
  const [printHistory, setPrintHistory] = useState<boolean>(false);
  const [paylate, setpaylate] = useState<boolean>(false);
  const [paycard, setpaycard] = useState<boolean>(false);
  const [cashpay, setcashpay] = useState<boolean>(false);
  const { user } = useUser();

  const businessArabicName = user?.organization_arabic_name || "";
  const businessLocation = user?.business_location || "";
  const paid = bproducts?.payments.reduce((sum: number, i: any) => sum + Number(i.ReceivedAmount), 0) || 0;
  const prvPaid =
    bproducts?.paymentHistory?.length && bproducts.paymentHistory.length > 1 && bproducts.paymentHistory[0]
      ? Number(bproducts.paymentHistory[0]?.ReceivedAmount ?? 0)
      : 0;
  const PreviousBalance =
    (bproducts?.Finalamount ?? 0) -
    (bproducts?.paymentHistory?.length && bproducts.paymentHistory.length > 1 ? (bproducts.paymentHistory[0]?.ReceivedAmount ?? 0) : 0);
  const printData = {
    CustomerName: bproducts?.CustomerName || "",
    CustomerPhon: bproducts?.CustomerPhoneNo?.toString() || "",
    OrderId: bproducts?.Orderid || "",
    OrderStatus: bproducts?.OrderStatus || "",
    Date: bproducts?.Orderdate || "",
    Time: bproducts?.Ordertime || "",
    Products: bproducts?.Products || [],
    Paid: paid,
    unpaid: Number(bproducts?.RemainingAmount),
    OSB: Number(outstangingamount),
    busnessName: sessionStorage.getItem("organization_name") || "",
    busnessArabicName: businessArabicName,
    businessLocation: businessLocation,
    paymentMethod: bproducts?.payments?.map((p: any) => p.Paymentmethod).join(", ") || "",
    phoneNum: sessionStorage.getItem("business_phone") || "",
    total: bproducts?.totalAmount || "",
    clientId: filteredCustomerId,
    billNo: bproducts?.billNumber,
    imglogo: logo,
    discount: Number(bproducts?.discount),
    deliveryFee: Number(bproducts?.deliveryFee || 0),
    subtotal: Number(getorder?.Finalamount),
    prvPaid: prvPaid,
    prvBalance: PreviousBalance,
    prvAvabile: false,
  };

  const Remainingpayments = getorder?.paymentHistory
    ? (getorder?.paymentHistory ?? []).reduce((sum: number, item: any) => sum + Number(item?.ReceivedAmount || 0), 0)
    : Number(getorder?.payments?.[0]?.ReceivedAmount || 0);
  const Receivedbalance = () => {
    if (!getorder) return 0;
    const receivedAmount = Number(getorder.payments[0]?.ReceivedAmount || 0);
    const finalAmount = Number(getorder.Finalamount || 0);
    if (receivedAmount > finalAmount) {
      return finalAmount;
    } else {
      if (getorder.paymentHistory && getorder.paymentHistory.length > 1) {
        return Remainingpayments;
      } else {
        return getorder.payments[0].ReceivedAmount;
      }
    }
  };

  const remaining = () => {
    const balance = Number(getorder?.RemainingAmount || 0);
    // return Number(outstangingamount) === 0 || balance <= 0 ? 0 : balance;
    return balance;
  };

  const roundValue = (value?: number): number => {
    if (value == null) return 0;
    const num = Number(value);
    const thirdDecimal = Math.floor(num * 1000) % 10;
    return thirdDecimal >= 5 ? Math.ceil(num * 100) / 100 : Math.floor(num * 100) / 100;
  };

  const cashoutstanging = Number(outstangingamount) - Number(getorder?.RemainingAmount);

  const Outamount = () => {
    if (showBalance === true) {
      // setcondition(0)
      const outstanging = Number(cashoutstanging);
      const remaining = Number(getorder?.RemainingAmount);
      const amount_in = outstanging + remaining;
      return amount_in;
    } else if (showBalance === false) {
      // setcondition(0)
      const remaining = getorder?.RemainingAmount;
      return remaining;
    }
  };

  const refundAmount = () => {
    const osb = Number(outstangingamount || 0);
    const orderOSB = Number(getorder?.RemainingAmount || 0);
    const orderCancelAmount = Number(roundValue(Receivedbalance() || 0));
    const currentOSB = osb - orderOSB;
    const orderTotalDeduction = currentOSB - orderCancelAmount;
    return orderTotalDeduction;
  };

  const handleclick = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    // Allow only numbers + optional decimal
    if (!/^\d*\.?\d*$/.test(newValue)) return;
    const maxAllowedValue = Outamount() ?? 0;
    // If empty → allow empty (no 0)
    if (newValue === "") {
      setInputValue("");
      setcondition(0);
      return;
    }
    // Prevent leading zero like "01", "02"
    if (newValue.length > 1 && newValue.startsWith("0") && !newValue.startsWith("0.")) {
      newValue = newValue.replace(/^0+/, ""); // remove leading zeros
    }
    const enteredValue = parseFloat(newValue);

    if (!isNaN(enteredValue)) {
      if (enteredValue <= maxAllowedValue) {
        setInputValue(newValue);
        setcondition(enteredValue);
      } else {
        setInputValue(maxAllowedValue.toString());
        setcondition(maxAllowedValue);
      }
    }
  };

  const handleBlur = () => {
    const formatted = Number(condition).toFixed(2);
    setInputValue(formatted);
  };

  const outstandingvalue = () => {
    setcondition(0);
    setInputValue("0");
    setShowBalance(!showBalance);
  };

  const payments = () => {
    if (paylate) {
      setmodel(true);
      setcashpay(false);
    }
    if (cashpay) {
      setglowery(true);
      setpaylate(false);
    }
    if (paycard) {
      setglowery(true);
      setpaylate(false);
    }
  };

  return {
    filteredCustomerId,
    setFilteredCustomerId,
    printData,
    Remainingpayments,
    Receivedbalance,
    remaining,
    roundValue,
    cashoutstanging,
    Outamount,
    refundAmount,
    handleclick,
    handleBlur,
    outstandingvalue,
    payments,
    printHistory,
    setInputValue,
    inputValue,
    condition,
    setcondition,
    model,
    glowery,
    confirm,
    setmodel,
    setglowery,
    setConfirm,
    setPrintHistory,
    setpaylate,
    setcashpay,
    paylate,
    cashpay,
    paycard,
    setpaycard,
  };
};
